<template>
  <section>
    <b-overlay
      :show='loading'
      opacity='0.7'
      spinner-small
      spinner-variant='primary'
      style='min-height: 200px'
      class='d-inline-block w-100'
    >
      <section class='w-100 text-center mt-3' v-if='user && user.id'>
        <h6>Usuário: <strong>{{ user.username }}</strong></h6>
        <h6>Data: <strong>{{ formatDate(user.currentDate) }}</strong></h6>
      </section>
      <section v-if="newCompanyHierarchyFormat">
        <section v-if='completeHierarchy.length > 0' class='mb-3'>
          <ul class='tree mt-5' v-for='(company, i) in completeHierarchy' :key='`${company._id}-${i}`'>
            <li>
              <section class='item'>
              <span>
                Empresa:&nbsp; {{ company.name }}
              </span>
              </section>
            </li>

            <ul v-for='(unit, y) in company.units' :key='`${unit._id}-${y}`'>
              <li>
                <section class='item'>
                <span>
                  Unidade :&nbsp; {{ unit.name }}
                </span>
                </section>
              </li>

              <ul v-for='(sector, z) in unit.sectors' :key='`${sector._id}-${z}`'>
                <li>
                  <section class='item'>
                    <span>
                      Setor:&nbsp; {{ sector.name }}
                    </span>
                    <span v-if='sector.ventilationWorkEnvironmentGeneral'>
                        Nível de ventilação:&nbsp;
                          {{
                            ventilationLevels.find((x) => x.key == sector.ventilationWorkEnvironmentGeneral).value
                          }}
                    </span>
                    <span v-else>Nível de ventilação: -</span>


                    <span
                      v-if="sector && sector.effectiveProtection && sector.effectiveProtection._id"
                    >
                      <span v-if="sector && sector.effectiveProtection && sector.effectiveProtection.pergunta_1_existeEquipamentoProtecaoColetivaAuxiliarControleRiscoQuimico != null">
                        Existe algum EQUIPAMENTO DE PROTEÇÃO COLETIVA para auxiliar no controle de risco químico?:
                        {{ sector.effectiveProtection.pergunta_1_existeEquipamentoProtecaoColetivaAuxiliarControleRiscoQuimico ? "Sim" : "Não" }}
                      </span>
                      <span v-else>Existe algum EQUIPAMENTO DE PROTEÇÃO COLETIVA para auxiliar no controle de risco químico?: -</span>

                      <span
                        v-if="sector && sector.effectiveProtection && sector.effectiveProtection.pergunta_1_existeEquipamentoProtecaoColetivaAuxiliarControleRiscoQuimico"
                      >
                        <span
                          v-if="sector && sector.effectiveProtection && sector.effectiveProtection.pergunta_1_1_OEPCFuncionandoAdequadamente != null"
                        >
                          O EPC está funcionando adequadamente?:
                          {{sector.effectiveProtection.pergunta_1_1_OEPCFuncionandoAdequadamente ? "Sim" : "Não" }}
                        </span>
                        <span v-else>O EPC está funcionando adequadamente?: -</span>


                        <span
                          v-if="sector && sector.effectiveProtection && sector.effectiveProtection.pergunta_1_2_EPCTemLaudoDocumentoAtestandoEficacia != null"
                        >
                          Existe alguma comprovação de que o EPC é suficiente para controlar a quantidade de agentes químicos presentes no ambiente de trabalho?:
                          {{sector.effectiveProtection.pergunta_1_2_EPCTemLaudoDocumentoAtestandoEficacia ? "Sim" : "Não" }}
                        </span>
                        <span v-else>Existe alguma comprovação de que o EPC é suficiente para controlar a quantidade de agentes químicos presentes no ambiente de trabalho?: -</span>


                        <span
                          v-if="sector && sector.effectiveProtection && sector.effectiveProtection.pergunta_1_3_LaudoDocumentoDentroPrazoPrevistoCronogramaManutencao != null"
                        >
                          Existe alguma comprovação ou evidência de que a exposição do trabalhador aos agentes nocivos foi eliminada?:
                          {{sector.effectiveProtection.pergunta_1_3_LaudoDocumentoDentroPrazoPrevistoCronogramaManutencao ? "Sim" : "Não" }}
                        </span>
                        <span v-else>Existe alguma comprovação ou evidência de que a exposição do trabalhador aos agentes nocivos foi eliminada?: -</span>
                      </span>
                    </span>
                    <span v-else>Existe algum EQUIPAMENTO DE PROTEÇÃO COLETIVA para auxiliar no controle de risco químico?: -</span>
                  </section>
                </li>

                <ul
                  v-show="sector.sectorRoles && sector.sectorRoles.length > 0"
                  v-for='(sectorRole, b) in sector.sectorRoles' :key='`${sectorRole._id}-${b}`'
                >
                  <li>
                    <section class='item'>
                      <span>
                        Cargo :&nbsp; {{ sectorRole.role.name }}
                      </span>
                        <span
                          style='max-width: 1000px'
                          v-if='sectorRole && sectorRole.role && sectorRole.role.activitiesDeveloped'
                        >
                        Atividades desenvolvidas:&nbsp; {{ sectorRole.role.activitiesDeveloped }}
                      </span>

                      <span
                        v-if='sectorRole.exposedWorkers'
                      >
                        Quantidade de trabalhadores expostos:&nbsp;
                        {{ sectorRole.exposedWorkers }}
                      </span>
                      <span v-else>Quantidade de trabalhadores expostos: -</span>


                      <span
                        v-if="sectorRole && sectorRole.effectiveProtection && sector.effectiveProtection._id"
                      >
                        <span v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06Topico != null">
                          <span v-if="sectorRole.effectiveProtection.pergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06Topico == 3">
                            O empregador ou organização cumpre e faz cumprir todos os itens da NR 06 em seu tópico 6.5?: Não se aplica
                          </span>
                          <span v-else>
                            O empregador ou organização cumpre e faz cumprir todos os itens da NR 06 em seu tópico 6.5?:
                            {{ sectorRole.effectiveProtection.pergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06Topico ? "Sim" : "Não" }}
                          </span>
                        </span>
                        <span v-else>O empregador ou organização cumpre e faz cumprir todos os itens da NR 06 em seu tópico 6.5?: -</span>

                        <span
                          v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06Topico && sectorRole.effectiveProtection.pergunta_2_empregadorOrganizacaoCumpreFazCumprirItensNR06Topico != 3"
                        >
                          <span
                            v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_1_todosEPIsEmpresaAdquiriuPossuemCA != null"
                          >
                            Todos os EPIs que a empresa adquiriu possuem CA (Certificado de aprovação)?:
                            {{sectorRole.effectiveProtection.pergunta_2_1_todosEPIsEmpresaAdquiriuPossuemCA ? "Sim" : "Não" }}
                          </span>
                          <span v-else>Todos os EPIs que a empresa adquiriu possuem CA (Certificado de aprovação)?: -</span>


                          <span
                            v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_2_empregadosForamPrientadosTreinadosSobreUsoEPI != null"
                          >
                            Os empregados foram orientados e treinados sobre o uso de EPI?:
                            {{sectorRole.effectiveProtection.pergunta_2_2_empregadosForamPrientadosTreinadosSobreUsoEPI ? "Sim" : "Não" }}
                          </span>
                          <span v-else>Os empregados foram orientados e treinados sobre o uso de EPI?: -</span>


                          <span
                            v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_3_EPIFornecidoGratuitoEmpregadoAssimMomentoFornecimentoEstavaPerfeitoEstadoConservacaooFormaAdequadaRisco != null"
                          >
                            O EPI fornecido foi gratuito ao empregado, assim como no momento do fornecimento estava em perfeito estado de conservação e de forma adequada ao risco?:
                            {{sectorRole.effectiveProtection.pergunta_2_3_EPIFornecidoGratuitoEmpregadoAssimMomentoFornecimentoEstavaPerfeitoEstadoConservacaooFormaAdequadaRisco ? "Sim" : "Não" }}
                          </span>
                          <span class="word-break" v-else>O EPI fornecido foi gratuito ao empregado, assim como no momento do fornecimento estava em perfeito estado de conservação e de forma adequada ao risco?: -</span>


                          <span
                            v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_4_fornecimentoEPISempreRegistrado != null"
                          >
                            O fornecimento do EPI foi e é sempre registrado?:
                            {{sectorRole.effectiveProtection.pergunta_2_4_fornecimentoEPISempreRegistrado ? "Sim" : "Não" }}
                          </span>
                          <span v-else>O fornecimento do EPI foi e é sempre registrado?: -</span>


                          <span
                            v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_5_empresaCaraterFiscalizacaoConstanteJuntoSeusEmpregadosEstaExigindoUsoEPI != null"
                          >
                            A empresa em caráter de fiscalização constante junto aos seus empregados está exigindo o uso do EPI?:
                            {{sectorRole.effectiveProtection.pergunta_2_5_empresaCaraterFiscalizacaoConstanteJuntoSeusEmpregadosEstaExigindoUsoEPI ? "Sim" : "Não" }}
                          </span>
                          <span v-else>A empresa em caráter de fiscalização constante junto aos seus empregados está exigindo o uso do EPI?: -</span>


                          <span
                            v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_6_empresaExecutaProcedimentosInternosParaRealizarHigienizacaoManutencaoPeriodicaEPIs != null"
                          >
                            A empresa executa e tem procedimentos internos para realizar a higienização e manutenção periódica dos EPIs?:
                            {{sectorRole.effectiveProtection.pergunta_2_6_empresaExecutaProcedimentosInternosParaRealizarHigienizacaoManutencaoPeriodicaEPIs ? "Sim" : "Não" }}
                          </span>
                          <span v-else>A empresa executa e tem procedimentos internos para realizar a higienização e manutenção periódica dos EPIs?: -</span>


                          <span
                            v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_7_empresaSubstituiImediatamenteEPICasoDeleEstarDanificadoExtraviado != null"
                          >
                            A empresa substitui imediatamente o EPI em caso dele estar danificado ou extraviado?:
                            {{sectorRole.effectiveProtection.pergunta_2_7_empresaSubstituiImediatamenteEPICasoDeleEstarDanificadoExtraviado ? "Sim" : "Não" }}
                          </span>
                          <span v-else>A empresa substitui imediatamente o EPI em caso dele estar danificado ou extraviado?: -</span>


                          <span
                            v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_2_8_empresaExecutaProcedimentosInternosParaCasoEPIApresenteIrregularidades != null"
                          >
                            A empresa executa e tem procedimentos internos para caso o EPI apresente irregularidades?:
                            {{sectorRole.effectiveProtection.pergunta_2_8_empresaExecutaProcedimentosInternosParaCasoEPIApresenteIrregularidades ? "Sim" : "Não" }}
                          </span>
                          <span v-else>A empresa executa e tem procedimentos internos para caso o EPI apresente irregularidades?: -</span>
                        </span>


                        <span v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66 != null">
                          <span v-if="sectorRole.effectiveProtection.pergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66 == 3">
                            O empregado ou trabalhador cumpre todos os itens da NR 06 em seu tópico 6.6?: Não se aplica
                          </span>
                          <span v-else>
                            O empregado ou trabalhador cumpre todos os itens da NR 06 em seu tópico 6.6?:
                            {{ sectorRole.effectiveProtection.pergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66 ? "Sim" : "Não" }}
                          </span>
                        </span>
                        <span v-else>O empregado ou trabalhador cumpre todos os itens da NR 06 em seu tópico 6.6?: -</span>
                        <span
                          style='max-width: 1000px'
                          v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66 && sectorRole.effectiveProtection.pergunta_3_empregadoTrabalhadorCumpreTodosItensNR06Topico66 != 3"
                        >
                            <span
                              v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_3_1_EPITrabalhadorUsaSomenteAqueleFornecidoPelaEmpresa != null"
                            >
                              O EPI que o trabalhador usa é somente aquele fornecido pela empresa?:
                              {{sectorRole.effectiveProtection.pergunta_3_1_EPITrabalhadorUsaSomenteAqueleFornecidoPelaEmpresa ? "Sim" : "Não" }}
                            </span>
                            <span v-else>O EPI que o trabalhador usa é somente aquele fornecido pela empresa?: -</span>


                            <span
                              v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_3_2_EPIUtilizadoPeloTrabalhadorEstaAlinhadoSuaNecessidadeFinalidadeRisco != null"
                            >
                              O EPI utilizado pelo trabalhador está alinhado com sua necessidade/finalidade/risco?:
                              {{sectorRole.effectiveProtection.pergunta_3_2_EPIUtilizadoPeloTrabalhadorEstaAlinhadoSuaNecessidadeFinalidadeRisco ? "Sim" : "Não" }}
                            </span>
                            <span v-else>O EPI utilizado pelo trabalhador está alinhado com sua necessidade/finalidade/risco?:  -</span>


                            <span
                              v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_3_3_trabalhadorEstaSendoResponsavelPelaLimpezaGuardaConservacaoEPI != null"
                            >
                              O trabalhador está sendo responsável pela limpeza, guarda e conservação do EPI?:
                              {{sectorRole.effectiveProtection.pergunta_3_3_trabalhadorEstaSendoResponsavelPelaLimpezaGuardaConservacaoEPI ? "Sim" : "Não" }}
                            </span>
                            <span v-else>O trabalhador está sendo responsável pela limpeza, guarda e conservação do EPI?:  -</span>


                            <span
                              v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_3_4_trabalhadorMatemComunicaaoComEmpresaParaInformarSituacoesEPIEstiverExtraviadoDanificadoQualquerAlteracaoTorneImproprioParaUso != null"
                            >
                              O trabalhador mantém boa comunicação com a empresa para informar situações em que o EPI estiver extraviado, danificado ou qualquer alteração que o torne impróprio para o uso?:
                              {{sectorRole.effectiveProtection.pergunta_3_4_trabalhadorMatemComunicaaoComEmpresaParaInformarSituacoesEPIEstiverExtraviadoDanificadoQualquerAlteracaoTorneImproprioParaUso ? "Sim" : "Não" }}
                            </span>
                            <span class="break-all" v-else>O trabalhador mantém boa comunicação com a empresa para informar situações em que o EPI estiver extraviado, danificado ou qualquer alteração que o torne impróprio para o uso?:  -</span>


                            <span
                              v-if="sectorRole && sectorRole.effectiveProtection && sectorRole.effectiveProtection.pergunta_3_5_trabalhadorCumpreDeterminacoeEmpresaQuantoUsoEPI != null"
                            >
                              O trabalhador cumpre as determinações da empresa quanto ao uso do EPI?:
                              {{sectorRole.effectiveProtection.pergunta_3_5_trabalhadorCumpreDeterminacoeEmpresaQuantoUsoEPI ? "Sim" : "Não" }}
                            </span>
                            <span v-else>O trabalhador cumpre as determinações da empresa quanto ao uso do EPI?:  -</span>
                          </span>

                      </span>
                      <span v-else>
                        <span>O empregador ou organização cumpre e faz cumprir todos os itens da NR 06 em seu tópico 6.5?: -</span>
                        <span>O empregado ou trabalhador cumpre todos os itens da NR 06 em seu tópico 6.6?: -</span>
                      </span>
                    </section>
                  </li>

                  <ul
                    v-show='sectorRole && sectorRole.role &&
                                    sectorRole.role.roleProductsLegalConsultation &&
                                    sectorRole.role.roleProductsLegalConsultation.length > 0 &&
                                    sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id).length > 0'
                    v-for='(roleProductLegalConsultation, a) in sectorRole.role.roleProductsLegalConsultation.filter(x => x.product && x.product._id)'
                    :key='`${roleProductLegalConsultation._id}-${a}`'
                  >
                    <li>
                      <section class='item'>
                        <span>
                          Produto:&nbsp; {{ roleProductLegalConsultation.product.name }}
                        </span>
                        <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.physicalState'>
                          Estado físico do produto:&nbsp;
                          {{
                            physicalProductStates.find((x) => x.key == roleProductLegalConsultation.product.physicalState).value
                          }}
                        </span>
                        <span v-else>
                          Estado físico do produto:&nbsp; -
                        </span>
                        <span style='max-width: 1000px'
                              v-if='roleProductLegalConsultation && roleProductLegalConsultation.description'>
                          Descrição:&nbsp; {{ roleProductLegalConsultation.description }}
                        </span>
                        <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.urlFISPQ'>
                          FDS ou FISPQ:&nbsp; <a
                          class='file-uploaded mt-3'
                          v-if='roleProductLegalConsultation.product.urlFISPQ'
                          :href='roleProductLegalConsultation.product.urlFISPQ'
                          target='_blank'
                        >
                          Acesse o sistema para ver o arquivo anexado
                           </a>
                        </span>
                        <span v-else>
                          FDS ou FISPQ: -
                        </span>
                      </section>
                    </li>
                    <ul>
                      <li>
                        <section class='item'>
                        <span>
                          Condições de uso: <br />
                        </span>
                          <section>
                            <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses.temperature'>
                              Temperatura °C:&nbsp; {{ roleProductLegalConsultation.product.termsofuses.temperature }}
                            </span>
                            <span v-else>
                              Temperatura °C: -
                            </span>


                            <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess'>
                              Nível de controle da ventilação:&nbsp;
                                {{
                                  roleProductLegalConsultation.product.termsofuses.isCustomControlLevel
                                    ? `Nível de Controle Personalizado (nível ${roleProductLegalConsultation.product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess} de 6)`
                                    : optionsVentilationIdentified.find((x) => x.key == roleProductLegalConsultation.product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess).value
                                }}
                            </span>
                            <span v-else>
                              Nível de controle da ventilação: -
                            </span>


                            <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses.quantityUsed'>
                                Quantidade diária utilizada deste produto (em kg ou L):&nbsp;
                              {{
                                optionsQuantityUsed.find((x) => x.key == roleProductLegalConsultation.product.termsofuses.quantityUsed).value
                               }}
                            </span>
                            <span v-else>Quantidade diária utilizada deste produto (em kg ou L): -</span>


                            <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses.frequencyUse'>
                              Frequência de utilização deste produto:&nbsp;
                              {{ optionsFrequencyUse.find((x) => x.key == roleProductLegalConsultation.product.termsofuses.frequencyUse).value }}
                            </span>
                            <span v-else>Frequência de utilização deste produto: -</span>


                            <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses.exposureTime'>
                              Tempo de exposição do trabalhador com o uso do produto (por dia):&nbsp;
                              {{ optionsExposureTime.find((x) => x.key == roleProductLegalConsultation.product.termsofuses.exposureTime).value }}
                            </span>
                            <span v-else>Tempo de exposição do trabalhador com o uso do produto (por dia): -</span>

                            <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses.physicalStateProduct'>
                              Estado Físico do Produto:&nbsp;
                              {{ physicalProductStates.find((x) => x.key == roleProductLegalConsultation.product.termsofuses.physicalStateProduct).value }}
                            </span>
                            <span v-else>Estado Físico do Produto: -</span>

                            <span v-if='roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.termsofuses && roleProductLegalConsultation.product.termsofuses.description'>
                              Descrição:&nbsp;
                              {{ roleProductLegalConsultation.product.termsofuses.description }}
                            </span>
                            <span v-else>Descrição: -</span>
                          </section>
                        </section>
                      </li>

                      <ul>
                        <li>
                          <section class='item'>
                            <span>
                              Agentes <br />
                            </span>

                            <span class='mb-2' v-for='(agent, a) in roleProductLegalConsultation.product.legalSearches'
                                  :key='`${agent._id}-${a}`'>
                              CAS: Agente: {{ agent.name }} <br />
                              % do agente no produto: {{ agent.percentage ? agent.percentage : '-' }}
                            </span>
                          </section>
                        </li>
                      </ul>

                      <ul>
                        <li>
                          <section class='item'>
                            <span>
                              Exposição Permanente: <br />
                            </span>

                            <span
                              v-if="roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.permanentExhibition && roleProductLegalConsultation.product.permanentExhibition.frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade != null"
                            >
                              A frequência em que o trabalhador realiza a atividade é previsível?:
                              {{roleProductLegalConsultation.product.permanentExhibition.frequenciaTrabalhadorRealizarAtividadefrequqnciaTrabalhadorRealizarAtividade ? "Sim" : "Não" }}
                            </span>
                            <span v-else>A frequência em que o trabalhador realiza a atividade é previsível?: -</span>

                            <span
                              v-if="roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.permanentExhibition && roleProductLegalConsultation.product.permanentExhibition.trabalhadorRealizeAtividadeSemPresencaSemNecessidadeEmpregoagentesQuimicos != null"
                            >
                              Quando o trabalhador realiza a atividade ele tem a possibilidade de não utilizar os produtos químicos?:
                              {{roleProductLegalConsultation.product.permanentExhibition.trabalhadorRealizeAtividadeSemPresencaSemNecessidadeEmpregoagentesQuimicos ? "Sim" : "Não" }}
                            </span>
                            <span v-else>Quando o trabalhador realiza a atividade ele tem a possibilidade de não utilizar os produtos químicos?: -</span>

                            <span
                              v-if="roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.permanentExhibition && roleProductLegalConsultation.product.permanentExhibition.trabalhadorexecutaAtividadeAgentesQuimicosAnalisados != null"
                            >
                              O trabalhador tem contato dermal e/ou respiratório ou até outra que possa trazer algum dano a sua saúde?:
                              {{roleProductLegalConsultation.product.permanentExhibition.trabalhadorexecutaAtividadeAgentesQuimicosAnalisados ? "Sim" : "Não" }}
                            </span>
                            <span v-else>O trabalhador está exposto aos agentes químicos de forma dermal ou respiratória?: -</span>
                            <span
                              v-if="roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.permanentExhibition && roleProductLegalConsultation.product.permanentExhibition.exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao != null"
                            >
                              A exposição ao agente químico ocorre de forma indissociável da função?:
                              {{roleProductLegalConsultation.product.permanentExhibition.exposicaoAgenteQuimicoOcorredeFormaIndissociavelFuncao ? "Sim" : "Não" }}
                            </span>
                            <span v-else>A exposição ao agente químico ocorre de forma indissociável da função?: -</span>
                            <span
                              v-if="roleProductLegalConsultation && roleProductLegalConsultation.product && roleProductLegalConsultation.product.permanentExhibition && roleProductLegalConsultation.product.permanentExhibition.foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente != null"
                            >
                              Foram identificadas todas as fontes e formas como o produto é liberado no ar ou no ambiente?:
                              {{roleProductLegalConsultation.product.permanentExhibition.foramIdentificadasTodasFontesFormasComoProdutoLiberadoNoArOuAmbiente ? "Sim" : "Não" }}
                            </span>
                            <span v-else>Foram identificadas todas as fontes e formas como o produto é liberado no ar ou no ambiente?: -</span>
                          </section>

                        </li>
                      </ul>
                    </ul>
                  </ul>
                </ul>
              </ul>
            </ul>
          </ul>
        </section>
      </section>

      <section v-else>
        <section v-if='completeHierarchy.length > 0' class='mb-3'>
          <ul class='tree mt-5' v-for='(company, i) in completeHierarchy' :key='`${company._id}-${i}`'>
            <li>
              <section class='item'>
            <span>
              Empresa:&nbsp; {{ company.name }}
            </span>
              </section>
            </li>

            <ul v-for='(unit, y) in company.units' :key='`${unit._id}-${y}`'>
              <li>
                <section class='item'>
              <span>
                Unidade :&nbsp; {{ unit.name }}
              </span>
                </section>
              </li>

              <ul v-for='(sector, z) in unit.sectors' :key='`${sector._id}-${z}`'>
                <li>
                  <section class='item'>
                <span>
                  Setor:&nbsp; {{ sector.name }}
                </span>
                  </section>
                </li>

                <ul v-for='(role, b) in sector.roles' :key='`${role._id}-${b}`'>
                  <li>
                    <section class='item'>
                  <span>
                    Cargo :&nbsp; {{ role.name }}
                  </span>
                      <span style='max-width: 1000px' v-if='role && role.activitiesDeveloped'>
                    Atividades desenvolvidas:&nbsp; {{ role.activitiesDeveloped }}
                  </span>
                    </section>
                  </li>

                  <ul v-for='(product, a) in role.products' :key='`${product._id}-${a}`'>
                    <li>
                      <section class='item'>
                      <span>
                        Produto:&nbsp; {{ product.name }}
                      </span>
                        <span v-if='product && product.physicalState'>
                        Estado físico do produto:&nbsp; {{ physicalProductStates.find((x) => x.key == product.physicalState).value
                          }}
                      </span>
                        <span v-else>
                        Estado físico do produto:&nbsp; -
                      </span>
                        <span style='max-width: 1000px' v-if='product && product.description'>
                        Descrição:&nbsp; {{ product.description }}
                      </span>
                        <span v-if='product && product.urlFISPQ'>
                        FDS ou FISPQ:&nbsp; <a
                          class='file-uploaded mt-3'
                          v-if='product.urlFISPQ'
                          :href='product.urlFISPQ'
                          target='_blank'
                        >
                        Acesse o sistema para ver o arquivo anexado
                         </a>
                      </span>
                      </section>
                    </li>

                    <ul>
                      <li>
                        <section class='item'>
                        <span>
                          Condições de uso: <br />
                        </span>
                          <section>
                            <span v-if='product && product.termsofuses && product.termsofuses.temperature'>
                              Temperatura °C:&nbsp; {{ product.termsofuses.temperature }}
                            </span>
                            <span v-else>Temperatura °C: -</span>


                            <span v-if='product && product.termsofuses && product.termsofuses.ventilationWorkEnvironmentGeneral'>
                              Nível de ventilação:&nbsp;
                              {{ ventilationLevels.find((x) => x.key == product.termsofuses.ventilationWorkEnvironmentGeneral).value }}
                            </span>
                            <span v-else>Nível de ventilação: -</span>


                            <span v-if='product && product.termsofuses && product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess'>
                              Nível de controle da ventilação:&nbsp;
                              {{ product.termsofuses.isCustomControlLevel
                                ? `Nível de Controle Personalizado (nível ${product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess} de 6)`
                                : optionsVentilationIdentified.find((x) => x.key == product.termsofuses.ventilationInstalledSpecificallyForTheProductionProcess).value }}
                            </span>
                            <span v-else>Nível de controle da ventilação: -</span>


                            <span v-if='product && product.termsofuses && product.termsofuses.quantityUsed'>
                              Quantidade diária utilizada deste produto (em kg ou L):&nbsp;
                              {{ optionsQuantityUsed.find((x) => x.key == product.termsofuses.quantityUsed).value }}
                            </span>
                            <span v-else>Quantidade diária utilizada deste produto (em kg ou L): -</span>


                            <span v-if='product && product.termsofuses && product.termsofuses.frequencyUse'>
                              Frequência de utilização deste produto:&nbsp;
                              {{ optionsFrequencyUse.find((x) => x.key == product.termsofuses.frequencyUse).value }}
                            </span>
                            <span v-else>Frequência de utilização deste produto: -</span>


                            <span v-if='product && product.termsofuses && product.termsofuses.exposureTime'>
                              Tempo de exposição do trabalhador com o uso do produto (por dia):&nbsp;
                              {{ optionsExposureTime.find((x) => x.key == product.termsofuses.exposureTime).value }}
                            </span>
                            <span v-else>Tempo de exposição do trabalhador com o uso do produto (por dia): -</span>


                            <span v-if='product && product.termsofuses && product.termsofuses.exposedWorkers'>
                              Quantidade de trabalhadores expostos:&nbsp;
                              {{ product.termsofuses.exposedWorkers }}
                            </span>
                            <span v-else>Quantidade de trabalhadores expostos: -</span>


                            <span v-if='product && product.termsofuses && product.termsofuses.physicalStateProduct'>
                              Estado Físico do Produto:&nbsp;
                              {{ physicalProductStates.find((x) => x.key == product.termsofuses.physicalStateProduct).value}}
                            </span>
                            <span v-else>Estado Físico do Produto: -</span>


                            <span v-if='product && product.termsofuses && product.termsofuses.description'>
                              Descrição:&nbsp;
                              {{  product.termsofuses.description }}
                            </span>
                            <span v-else>Descrição: -</span>
                          </section>
                        </section>
                      </li>

                      <ul>
                        <li>
                          <section class='item'>
                          <span>
                            Agentes <br />
                          </span>

                            <span class='mb-2' v-for='(agent, a) in product.legalSearches' :key='`${agent._id}-${a}`'>
                            CAS: Agente: {{ agent.name }} <br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;% do agente no produto: {{ agent.percentage }}
                          </span>
                          </section>
                        </li>
                      </ul>
                    </ul>
                  </ul>
                </ul>
              </ul>
            </ul>
          </ul>
        </section>
      </section>
    </b-overlay>
  </section>
</template>

<script>
import format from 'date-fns/esm/format/index'
import api from '../utils/api'
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import { ventilationLevels } from '@/mocks/ventilationLevels'
import { optionsVentilationIdentified } from '@/mocks/optionsVentilationIdentified'
import { optionsExposureTime } from '@/mocks/optionsExposureTime'
import { optionsFrequencyUse } from '@/mocks/optionsFrequencyUse'
import { optionsQuantityUsed } from '@/mocks/optionsQuantityUsed'
import { physicalProductStates } from '@/mocks/physicalProductStates'

export default {
  name: 'Hierarchy',
  data() {
    return {
      completeHierarchy: [],
      simplifiedHierarchy: [],
      ventilationLevels: [],
      optionsVentilationIdentified: [],
      optionsExposureTime: [],
      optionsFrequencyUse: [],
      optionsQuantityUsed: [],
      physicalProductStates: [],
      /*user: {},*/
      companyId: null,
      loading: false,
      dateNewFormatCompanyHierarchy: new Date(),
      newCompanyHierarchyFormat: true
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/current']
    }
  },
  methods: {
    ...mapActions('hierarchy', {
      handleGetHierarchy: 'handleGetHierarchy'
    }),
    ...mapActions('companyLegalConsultation', {
      handleGetCompleteHierarchyCompanyLegalConsultation: 'handleGetCompleteHierarchyCompanyLegalConsultation'
    }),
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    },
    async getCompany() {
      try {
        const { data, status } = await this.handleGetCompleteHierarchyCompanyLegalConsultation({ id: this.companyId })
        console.log(data)
        const { company } = data
        this.dateNewFormatCompanyHierarchy = new Date(process.env.VUE_APP_DATE_NEW_FORMAT_COMPANY_HIERARCHY)
        this.newCompanyHierarchyFormat = moment(new Date(company.createdAt)).isSameOrAfter(moment(this.dateNewFormatCompanyHierarchy))
        this.completeHierarchy = [company]
      } catch (e) {
      }
    }
  },
  async mounted() {
    try {
      Object.assign(this.ventilationLevels, ventilationLevels)
      this.ventilationLevels = ventilationLevels
      Object.assign(this.optionsVentilationIdentified, optionsVentilationIdentified)
      this.optionsVentilationIdentified = optionsVentilationIdentified
      Object.assign(this.optionsExposureTime, optionsExposureTime)
      this.optionsExposureTime = optionsExposureTime
      Object.assign(this.optionsFrequencyUse, optionsFrequencyUse)
      this.optionsFrequencyUse = optionsFrequencyUse
      Object.assign(this.optionsQuantityUsed, optionsQuantityUsed)
      this.optionsQuantityUsed = optionsQuantityUsed
      Object.assign(this.physicalProductStates, physicalProductStates)
      this.physicalProductStates = physicalProductStates
      this.loading = true
      const { companyId } = this.$route.params
      this.companyId = companyId
      await this.getCompany()
      const sessionId = localStorage.getItem('sessionId')
      const user = (await this.$api.get(`users/${sessionId}`)).data
      await this.$store.dispatch('user/updateUser', user)
      setTimeout(() => {
        //window.print()
      }, 1000)
      this.loading = false
    } catch (e) {

    }

  }
}
</script>

<style lang='scss' scoped>
.tree,
.tree ul {
  margin: 20px 0;
  padding: 0;
  list-style: none;
  color: var(--navy-blue);
  position: relative;

}

.tree ul {
  margin-left: 2.5em
}

.tree:before,
.tree ul:before {
  content: "";
  display: block;
  width: 0;
  position: absolute;
  top: -20px;
  bottom: 0;
  left: 4px;
  border-left: 1px solid #B6B6B6;
}

ul.tree:before {
  border-left: none
}

.tree li {
  margin: 0;
  padding: 0 2em;
  line-height: 2em;
  font-weight: bold;
  position: relative;
}

.tree span,
.tree folder {
  display: block;
}

.tree li:before {
  content: "";
  display: block;
  width: 30px;
  height: 0;
  border-top: 1px solid #B6B6B6;
  margin-top: 1px;
  position: absolute;
  top: 1em;
  left: 4px;
}

ul.tree > li:before {
  border-top: none;
}

.item {
  width: max-content;
  margin-left: 10px;
  //padding-left: 3px;
}

.type-hierarchy {
  margin: 0 35px -30px 35px;
  border-bottom: 1px solid var(--navy-blue);

  .text-type-hierarchy {

  }
}
</style>
